// src/themes/platformThemes.js

export const THEMES = {

  // =====================================================
  // 1. CLASSIC DARK
  // =====================================================
  DARK: {
    name: "Dark",

    // =====================================================
    // BASE LAYOUT
    // =====================================================
    bg: "bg-gray-950",
    card: "bg-gray-900",
    nav: "bg-gray-900",

    // =====================================================
    // TEXT COLORS
    // =====================================================
    text: "text-gray-100",
    subText: "text-gray-300",

    // =====================================================
    // ACCENTS
    // =====================================================
    accent: "text-teal-300",
    accentBg: "bg-teal-600",

    // =====================================================
    // BORDERS / EFFECTS
    // =====================================================
    border: "border-gray-700",
    glow: "shadow-teal-500/20",

    // =====================================================
    // HOVER STATES
    // =====================================================
    hover: "hover:bg-gray-800",

    // Universal tab hover
    tabHover: "hover:bg-blue-600 hover:text-white",

    // =====================================================
    // BUTTONS
    // =====================================================
    buttonPrimary:
        "bg-teal-600 hover:bg-teal-700 text-white",

    buttonSecondary:
        "bg-gray-800 hover:bg-gray-700 text-gray-200",

    // =====================================================
    // TAB STATES
    // =====================================================
    tabActive:
        "bg-teal-600 text-white border-teal-400 shadow-lg",

    tabInactive:
        "bg-gray-800 text-gray-300 border-gray-700",

    // =====================================================
    // STATUS COLORS
    // =====================================================
    danger: "bg-red-600 text-white",

    success: "bg-green-600 text-white",

    warning: "bg-yellow-500 text-black",
    },

  // =====================================================
  // 2. LIGHT
  // =====================================================
  LIGHT: {
    name: "Light",

    // =====================================================
    // BASE LAYOUT
    // =====================================================
    bg: "bg-gray-100",
    card: "bg-white",
    nav: "bg-white",

    // =====================================================
    // TEXT COLORS
    // =====================================================
    text: "text-gray-900",
    subText: "text-gray-600",

    // =====================================================
    // ACCENTS
    // =====================================================
    accent: "text-blue-600",
    accentBg: "bg-blue-600",

    // =====================================================
    // BORDERS / EFFECTS
    // =====================================================
    border: "border-gray-300",
    glow: "shadow-blue-500/10",

    // =====================================================
    // HOVER STATES
    // =====================================================
    hover: "hover:bg-gray-100",

    // Universal tab hover
    tabHover: "hover:bg-blue-600 hover:text-white",

    // =====================================================
    // BUTTONS
    // =====================================================
    buttonPrimary:
        "bg-blue-600 hover:bg-blue-700 text-white",

    buttonSecondary:
        "bg-gray-200 hover:bg-gray-300 text-gray-800",

    // =====================================================
    // TAB STATES
    // =====================================================
    tabActive:
        "bg-blue-600 text-white border-blue-400 shadow-lg",

    tabInactive:
        "bg-gray-200 text-gray-800 border-gray-300",

    // =====================================================
    // STATUS COLORS
    // =====================================================
    danger: "bg-red-500 text-white",

    success: "bg-green-500 text-white",

    warning: "bg-yellow-400 text-black",
},

  // =====================================================
  // 3. MIDNIGHT OPS
  // =====================================================
  MIDNIGHT_OPS: {
    name: "Midnight Ops",

    // =====================================================
    // BASE LAYOUT
    // =====================================================
    bg: "bg-slate-950",
    card: "bg-slate-900",
    nav: "bg-slate-950",

    // =====================================================
    // TEXT COLORS
    // =====================================================
    text: "text-white",
    subText: "text-slate-300",

    // =====================================================
    // ACCENTS
    // =====================================================
    accent: "text-cyan-300",
    accentBg: "bg-cyan-600",

    // =====================================================
    // BORDERS / EFFECTS
    // =====================================================
    border: "border-slate-700",
    glow: "shadow-cyan-500/20",

    // =====================================================
    // HOVER STATES
    // =====================================================
    hover: "hover:bg-slate-800",

    // Universal tab hover
    tabHover: "hover:bg-blue-600 hover:text-white",

    // =====================================================
    // BUTTONS
    // =====================================================
    buttonPrimary:
        "bg-cyan-600 hover:bg-cyan-700 text-white",

    buttonSecondary:
        "bg-slate-800 hover:bg-slate-700 text-slate-200",

    // =====================================================
    // TAB STATES
    // =====================================================
    tabActive:
        "bg-cyan-600 text-white border-cyan-400 shadow-lg",

    tabInactive:
        "bg-slate-800 text-slate-300 border-slate-700",

    // =====================================================
    // STATUS COLORS
    // =====================================================
    danger: "bg-red-700 text-white",

    success: "bg-emerald-600 text-white",

    warning: "bg-amber-500 text-black",
    },

  // =====================================================
// 4. SYNTHWAVE AI
// =====================================================

SYNTHWAVE_AI: {
  name: "Synthwave AI",

  // =====================================================
  // BASE LAYOUT
  // =====================================================
  bg: "bg-black",
  card: "bg-fuchsia-950/40",
  nav: "bg-black",

  // =====================================================
  // TEXT COLORS
  // =====================================================
  text: "text-cyan-200",
  subText: "text-fuchsia-300",

  // =====================================================
  // ACCENTS
  // =====================================================
  accent: "text-pink-400",
  accentBg: "bg-pink-500",

  // =====================================================
  // BORDERS / EFFECTS
  // =====================================================
  border: "border-cyan-500",
  glow: "shadow-pink-500/30",

  // =====================================================
  // HOVER STATES
  // =====================================================
  hover: "hover:bg-fuchsia-900/40",

  tabHover: "hover:bg-blue-600 hover:text-white",

  // =====================================================
  // BUTTONS
  // =====================================================
  buttonPrimary:
    "bg-pink-500 hover:bg-pink-600 text-white",

  buttonSecondary:
    "bg-cyan-950 hover:bg-cyan-900 text-cyan-200",

  // =====================================================
  // TAB STATES
  // =====================================================
  tabActive:
    "bg-pink-500 text-white border-pink-300 shadow-lg",

  tabInactive:
    "bg-fuchsia-950/40 text-cyan-200 border-cyan-500",

  // =====================================================
  // STATUS COLORS
  // =====================================================
  danger: "bg-red-600 text-white",

  success: "bg-green-500 text-black",

  warning: "bg-yellow-400 text-black",
},

// =====================================================
// 5. SOFT PASTEL
// =====================================================

SOFT_PASTEL: {
  name: "Soft Pastel",

  // =====================================================
  // BASE LAYOUT
  // =====================================================
  bg: "bg-pink-50",
  card: "bg-white",
  nav: "bg-pink-100",

  // =====================================================
  // TEXT COLORS
  // =====================================================
  text: "text-pink-900",
  subText: "text-pink-600",

  // =====================================================
  // ACCENTS
  // =====================================================
  accent: "text-rose-500",
  accentBg: "bg-rose-500",

  // =====================================================
  // BORDERS / EFFECTS
  // =====================================================
  border: "border-pink-200",
  glow: "shadow-rose-300/20",

  // =====================================================
  // HOVER STATES
  // =====================================================
  hover: "hover:bg-pink-100",

  tabHover: "hover:bg-blue-600 hover:text-white",

  // =====================================================
  // BUTTONS
  // =====================================================
  buttonPrimary:
    "bg-rose-500 hover:bg-rose-600 text-white",

  buttonSecondary:
    "bg-pink-200 hover:bg-pink-300 text-pink-900",

  // =====================================================
  // TAB STATES
  // =====================================================
  tabActive:
    "bg-rose-500 text-white border-rose-300 shadow-lg",

  tabInactive:
    "bg-pink-100 text-pink-800 border-pink-200",

  // =====================================================
  // STATUS COLORS
  // =====================================================
  danger: "bg-red-400 text-white",

  success: "bg-emerald-400 text-white",

  warning: "bg-yellow-300 text-black",
},

// =====================================================
// 6. DEEPTECH BLACK
// =====================================================

DEEPTECH_BLACK: {
  name: "DeepTech Black",

  // =====================================================
  // BASE LAYOUT
  // =====================================================
  bg: "bg-black",
  card: "bg-zinc-950",
  nav: "bg-black",

  // =====================================================
  // TEXT COLORS
  // =====================================================
  text: "text-yellow-100",
  subText: "text-zinc-400",

  // =====================================================
  // ACCENTS
  // =====================================================
  accent: "text-cyan-400",
  accentBg: "bg-cyan-600",

  // =====================================================
  // BORDERS / EFFECTS
  // =====================================================
  border: "border-zinc-800",
  glow: "shadow-cyan-500/30",

  // =====================================================
  // HOVER STATES
  // =====================================================
  hover: "hover:bg-zinc-900",

  tabHover: "hover:bg-blue-600 hover:text-white",

  // =====================================================
  // BUTTONS
  // =====================================================
  buttonPrimary:
    "bg-cyan-600 hover:bg-cyan-700 text-white",

  buttonSecondary:
    "bg-zinc-900 hover:bg-zinc-800 text-zinc-100",

  // =====================================================
  // TAB STATES
  // =====================================================
  tabActive:
    "bg-cyan-600 text-white border-cyan-400 shadow-lg",

  tabInactive:
    "bg-zinc-950 text-yellow-100 border-zinc-800",

  // =====================================================
  // STATUS COLORS
  // =====================================================
  danger: "bg-red-700 text-white",

  success: "bg-emerald-600 text-white",

  warning: "bg-yellow-500 text-black",
},

  // =====================================================
// 7. COGNITIVE GLASS
// =====================================================

COGNITIVE_GLASS: {
  name: "Cognitive Glass",

  bg: "bg-slate-950",
  card: "bg-white/10 backdrop-blur-xl",
  nav: "bg-slate-950/80 backdrop-blur-lg",

  text: "text-cyan-100",
  subText: "text-slate-300",

  accent: "text-cyan-300",
  accentBg: "bg-cyan-500/80",

  border: "border-white/20",

  hover: "hover:bg-white/10 hover:text-white",

  tabActive:
    "bg-cyan-500 text-white border-cyan-300 shadow-lg shadow-cyan-500/30",

  tabInactive:
    "bg-white/5 text-cyan-100 border-white/10 hover:bg-cyan-600 hover:text-white",

  tabHover:
    "hover:bg-cyan-600 hover:text-white",

  tableHeader:
    "bg-cyan-500/20 text-cyan-100 border-white/10",

  tableRow:
    "bg-white/5 text-cyan-50 border-white/10 hover:bg-white/10 hover:text-white",

  buttonPrimary:
    "bg-cyan-500 hover:bg-cyan-600 text-white",

  buttonSecondary:
    "bg-white/10 hover:bg-cyan-600 hover:text-white text-cyan-100",

  danger: "bg-red-600/90 text-white",
  success: "bg-emerald-500/90 text-white",
  warning: "bg-yellow-400/90 text-black",

  glow: "shadow-cyan-400/40",
},

// =====================================================
// 8. BHARAT BRIGHT
// =====================================================

BHARAT_BRIGHT: {
  name: "Bharat Bright",

  bg: "bg-orange-200",
  card: "bg-white",
  nav: "bg-orange-100",

  text: "text-orange-900",
  subText: "text-green-700",

  accent: "text-blue-600",
  accentBg: "bg-orange-500",

  border: "border-orange-200",

  hover: "hover:bg-orange-100 hover:text-white",

  tabActive:
    "bg-orange-500 text-white border-orange-400 shadow-md shadow-orange-400/30",

  tabInactive:
    "bg-white text-orange-900 border-orange-200 hover:bg-orange-500 hover:text-white",

  tabHover:
    "hover:bg-orange-500 hover:text-white",

  tableHeader:
    "bg-orange-500 text-white border-orange-300",

  tableRow:
    "bg-white text-orange-900 border-orange-100 hover:bg-orange-100 hover:text-black",

  buttonPrimary:
    "bg-orange-500 hover:bg-orange-600 text-white",

  buttonSecondary:
    "bg-green-500 hover:bg-green-600 text-white",

  danger: "bg-red-500 text-white",
  success: "bg-green-600 text-white",
  warning: "bg-yellow-400 text-black",

  glow: "shadow-orange-400/20",
},

// =====================================================
// 9. CAMPUS JOY
// =====================================================

CAMPUS_JOY: {
  name: "Campus Joy",

  bg: "bg-violet-200",
  card: "bg-white",
  nav: "bg-violet-100",

  text: "text-violet-900",
  subText: "text-fuchsia-600",

  accent: "text-cyan-500",
  accentBg: "bg-fuchsia-500",

  border: "border-violet-200",

  hover: "hover:bg-violet-100 hover:text-white",

  tabActive:
    "bg-fuchsia-500 text-white border-fuchsia-400 shadow-md shadow-fuchsia-400/30",

  tabInactive:
    "bg-white text-violet-900 border-violet-200 hover:bg-fuchsia-500 hover:text-white",

  tabHover:
    "hover:bg-fuchsia-500 hover:text-white",

  tableHeader:
    "bg-fuchsia-500 text-white border-fuchsia-300",

  tableRow:
    "bg-white text-violet-900 border-violet-100 hover:bg-violet-100 hover:text-black",

  buttonPrimary:
    "bg-fuchsia-500 hover:bg-fuchsia-600 text-white",

  buttonSecondary:
    "bg-cyan-500 hover:bg-cyan-600 text-white",

  danger: "bg-red-500 text-white",
  success: "bg-lime-500 text-black",
  warning: "bg-yellow-300 text-black",

  glow: "shadow-fuchsia-400/20",
},

// =====================================================
// 10. VILLAGE CONNECT
// =====================================================

VILLAGE_CONNECT: {
  name: "Village Connect",

  bg: "bg-yellow-200",
  card: "bg-white",
  nav: "bg-green-100",

  text: "text-amber-900",
  subText: "text-green-700",

  accent: "text-green-700",
  accentBg: "bg-green-600",

  border: "border-yellow-300",

  hover: "hover:bg-yellow-100 hover:text-white",

  tabActive:
    "bg-green-600 text-white border-green-500 shadow-md shadow-green-400/30",

  tabInactive:
    "bg-white text-amber-900 border-yellow-300 hover:bg-green-600 hover:text-white",

  tabHover:
    "hover:bg-green-600 hover:text-white",

  tableHeader:
    "bg-green-600 text-white border-green-500",

  tableRow:
    "bg-white text-amber-900 border-yellow-200 hover:bg-yellow-100 hover:text-black",

  buttonPrimary:
    "bg-green-600 hover:bg-green-700 text-white",

  buttonSecondary:
    "bg-amber-400 hover:bg-amber-500 text-black",

  danger: "bg-red-600 text-white",
  success: "bg-green-500 text-white",
  warning: "bg-yellow-400 text-black",

  glow: "shadow-green-400/20",
},

  // =====================================================
// 11. EMERALD CORPORATE
// =====================================================

EMERALD_CORPORATE: {
  name: "Emerald Corporate",

  bg: "bg-emerald-50",
  card: "bg-white",
  nav: "bg-emerald-100",

  text: "text-emerald-950",
  subText: "text-emerald-700",

  accent: "text-emerald-600",
  accentBg: "bg-emerald-600",

  border: "border-emerald-200",

  hover: "hover:bg-emerald-100 hover:text-white",

  tabActive:
    "bg-emerald-600 text-white border-emerald-500 shadow-md shadow-emerald-400/30",

  tabInactive:
    "bg-white text-emerald-950 border-emerald-200 hover:bg-emerald-600 hover:text-white",

  tabHover:
    "hover:bg-emerald-600 hover:text-white",

  tableHeader:
    "bg-emerald-600 text-white border-emerald-400",

  tableRow:
    "bg-white text-emerald-950 border-emerald-100 hover:bg-emerald-100 hover:text-black",

  buttonPrimary:
    "bg-emerald-600 hover:bg-emerald-700 text-white",

  buttonSecondary:
    "bg-slate-200 hover:bg-slate-300 text-slate-900",

  danger: "bg-red-500 text-white",
  success: "bg-emerald-500 text-white",
  warning: "bg-yellow-400 text-black",

  glow: "shadow-emerald-400/20",
},

// =====================================================
// 12. HOSTEL EARTH
// =====================================================

HOSTEL_EARTH: {
  name: "Hostel Earth",

  bg: "bg-stone-100",
  card: "bg-stone-50",
  nav: "bg-stone-200",

  text: "text-stone-900",
  subText: "text-stone-600",

  accent: "text-lime-700",
  accentBg: "bg-lime-700",

  border: "border-stone-300",

  hover: "hover:bg-stone-200 hover:text-white",

  tabActive:
    "bg-lime-700 text-white border-lime-600 shadow-md shadow-lime-500/30",

  tabInactive:
    "bg-stone-50 text-stone-900 border-stone-300 hover:bg-lime-700 hover:text-white",

  tabHover:
    "hover:bg-lime-700 hover:text-white",

  tableHeader:
    "bg-lime-700 text-white border-lime-600",

  tableRow:
    "bg-stone-50 text-stone-900 border-stone-200 hover:bg-stone-200 hover:text-black",

  buttonPrimary:
    "bg-lime-700 hover:bg-lime-800 text-white",

  buttonSecondary:
    "bg-stone-300 hover:bg-stone-400 text-stone-900",

  danger: "bg-red-500 text-white",
  success: "bg-green-600 text-white",
  warning: "bg-yellow-500 text-black",

  glow: "shadow-lime-500/10",
},

  // =====================================================
  // 13. EMERGENCY CRIMSON
  // =====================================================

  EMERGENCY_CRIMSON: {
    name: "Emergency Crimson",

    // Base
    bg: "bg-red-950",
    card: "bg-red-900",
    nav: "bg-black",

    // Text
    text: "text-red-100",
    subText: "text-red-300",

    // Accent
    accent: "text-yellow-300",
    accentBg: "bg-red-600",

    // Borders / effects
    border: "border-red-700",
    glow: "shadow-red-500/30",

    // Hover
    hover: "hover:bg-red-800",
    tabHover: "hover:bg-blue-600 hover:text-white",

    // Buttons
    buttonPrimary: "bg-red-600 hover:bg-red-700 text-white",
    buttonSecondary: "bg-black hover:bg-zinc-900 text-red-200",

    // Tabs
    tabActive:
        "bg-red-600 text-white border-red-400 shadow-lg",

    tabInactive:
        "bg-red-900 text-red-200 border-red-700",

    // Status
    danger: "bg-yellow-500 text-black",
    success: "bg-green-500 text-black",
    warning: "bg-yellow-400 text-black",
  },

  // =====================================================
// 14. RAINBOW LITE
// =====================================================

RAINBOW_LITE: {
  name: "Rainbow Lite",

  bg: "bg-sky-50",
  card: "bg-white",
  nav: "bg-pink-100",

  text: "text-sky-900",
  subText: "text-violet-600",

  accent: "text-pink-500",
  accentBg: "bg-pink-500",

  border: "border-sky-200",

  hover: "hover:bg-pink-50 hover:text-white",

  tabActive:
    "bg-pink-500 text-white border-pink-400 shadow-md shadow-pink-300/30",

  tabInactive:
    "bg-white text-sky-900 border-sky-200 hover:bg-pink-500 hover:text-white",

  tabHover:
    "hover:bg-pink-500 hover:text-white",

  tableHeader:
    "bg-pink-500 text-white border-pink-300",

  tableRow:
    "bg-white text-sky-900 border-sky-100 hover:bg-pink-50 hover:text-black",

  buttonPrimary:
    "bg-pink-500 hover:bg-pink-600 text-white",

  buttonSecondary:
    "bg-sky-500 hover:bg-sky-600 text-white",

  danger: "bg-red-400 text-white",
  success: "bg-green-400 text-black",
  warning: "bg-yellow-300 text-black",

  glow: "shadow-pink-300/20",
},

// =====================================================
// 15. NEOBRUTAL OPS
// =====================================================

NEOBRUTAL_OPS: {
  name: "NeoBrutal Ops",

  bg: "bg-yellow-100",
  card: "bg-white",
  nav: "bg-black",

  text: "text-black",
  subText: "text-gray-700",

  accent: "text-blue-700",
  accentBg: "bg-yellow-400",

  border: "border-4 border-black",

  hover: "hover:translate-x-1 hover:-translate-y-1 hover:text-white",

  tabActive:
    "bg-yellow-400 text-black border-4 border-black shadow-[4px_4px_0px_0px_rgba(0,0,0,1)]",

  tabInactive:
    "bg-white text-black border-4 border-black hover:bg-blue-600 hover:text-white",

  tabHover:
    "hover:bg-blue-600 hover:text-white",

  tableHeader:
    "bg-black text-yellow-200 border-4 border-black",

  tableRow:
    "bg-white text-black border-4 border-black hover:bg-yellow-100 hover:text-black",

  buttonPrimary:
    "bg-black hover:bg-gray-900 text-yellow-200 border-4 border-black",

  buttonSecondary:
    "bg-blue-500 hover:bg-blue-600 text-white border-4 border-black",

  danger: "bg-red-600 text-white border-4 border-black",
  success: "bg-green-500 text-black border-4 border-black",
  warning: "bg-yellow-400 text-black border-4 border-black",

  glow: "shadow-[6px_6px_0px_0px_rgba(0,0,0,1)]",
},

// =====================================================
// 16. HOLOGRAPHIC FUTURE
// =====================================================

HOLOGRAPHIC_FUTURE: {
  name: "Holographic Future",

  bg: "bg-gradient-to-br from-slate-950 via-indigo-950 to-cyan-950",
  card: "bg-white/10 backdrop-blur-2xl",
  nav: "bg-black/40 backdrop-blur-xl",

  text: "text-cyan-100",
  subText: "text-violet-200",

  accent: "text-fuchsia-300",
  accentBg: "bg-fuchsia-500",

  border: "border border-cyan-400/30",

  hover: "hover:bg-cyan-500/10 hover:text-white",

  tabActive:
    "bg-fuchsia-500 text-white border-cyan-300 shadow-lg shadow-fuchsia-500/40",

  tabInactive:
    "bg-white/5 text-cyan-100 border-cyan-400/20 hover:bg-cyan-600 hover:text-white",

  tabHover:
    "hover:bg-cyan-600 hover:text-white",

  tableHeader:
    "bg-fuchsia-500/80 text-white border-cyan-400/30",

  tableRow:
    "bg-white/5 text-cyan-100 border-cyan-400/10 hover:bg-cyan-500/10 hover:text-white",

  buttonPrimary:
    "bg-fuchsia-500 hover:bg-fuchsia-600 text-white",

  buttonSecondary:
    "bg-cyan-500 hover:bg-cyan-600 text-black",

  danger: "bg-red-500 text-white",
  success: "bg-green-400 text-black",
  warning: "bg-yellow-300 text-black",

  glow: "shadow-fuchsia-500/40",
},

// =====================================================
// 17. LIQUID INTELLIGENCE
// =====================================================

LIQUID_INTELLIGENCE: {
  name: "Liquid Intelligence",

  bg: "bg-gradient-to-br from-cyan-100 via-blue-50 to-violet-100",
  card: "bg-white/60 backdrop-blur-xl",
  nav: "bg-white/40 backdrop-blur-lg",

  text: "text-slate-900",
  subText: "text-slate-600",

  accent: "text-cyan-700",
  accentBg: "bg-cyan-500",

  border: "border border-white/40",

  hover: "hover:bg-cyan-50 hover:text-white",

  tabActive:
    "bg-cyan-500 text-white border-cyan-400 shadow-md shadow-cyan-300/30",

  tabInactive:
    "bg-white/50 text-slate-900 border-white/40 hover:bg-cyan-500 hover:text-white",

  tabHover:
    "hover:bg-cyan-500 hover:text-white",

  tableHeader:
    "bg-cyan-500 text-white border-white/40",

  tableRow:
    "bg-white/50 text-slate-900 border-white/30 hover:bg-cyan-50 hover:text-black",

  buttonPrimary:
    "bg-cyan-500 hover:bg-cyan-600 text-white",

  buttonSecondary:
    "bg-violet-500 hover:bg-violet-600 text-white",

  danger: "bg-red-500 text-white",
  success: "bg-emerald-500 text-white",
  warning: "bg-yellow-400 text-black",

  glow: "shadow-cyan-300/30",
},

  // =====================================================
// 18. SOFT NEUMORPH
// =====================================================

SOFT_NEUMORPH: {
  name: "Soft Neumorph",

  bg: "bg-slate-200",

  card:
    "bg-slate-200 shadow-[8px_8px_16px_#bec8d2,-8px_-8px_16px_#ffffff]",

  nav: "bg-slate-200",

  text: "text-slate-800",
  subText: "text-slate-500",

  accent: "text-indigo-600",
  accentBg: "bg-indigo-500",

  border: "border border-slate-200",

  hover: "hover:shadow-inner hover:text-white",

  tabActive:
    "bg-indigo-500 text-white border-indigo-400 shadow-lg shadow-indigo-300/30",

  tabInactive:
    "bg-slate-200 text-slate-800 border-slate-200 hover:bg-indigo-500 hover:text-white hover:shadow-inner",

  tabHover:
    "hover:bg-indigo-500 hover:text-white",

  tableHeader:
    "bg-indigo-500 text-white border-slate-200",

  tableRow:
    "bg-slate-200 text-slate-800 border-slate-200 hover:bg-slate-300 hover:text-black",

  buttonPrimary:
    "bg-indigo-500 hover:bg-indigo-600 text-white shadow-lg",

  buttonSecondary:
    "bg-slate-300 hover:bg-slate-400 text-slate-800",

  danger: "bg-red-400 text-white",
  success: "bg-green-500 text-white",
  warning: "bg-yellow-300 text-black",

  glow: "shadow-indigo-300/20",
},

// =====================================================
// 19. FESTIVAL INDIA
// =====================================================

FESTIVAL_INDIA: {
  name: "Festival India",

  bg: "bg-gradient-to-br from-orange-100 via-pink-100 to-yellow-100",

  card: "bg-white",

  nav:
    "bg-gradient-to-r from-orange-400 via-pink-500 to-yellow-400",

  text: "text-orange-950",
  subText: "text-pink-700",

  accent: "text-red-600",
  accentBg: "bg-orange-500",

  border: "border-orange-300",

  hover: "hover:bg-orange-50 hover:text-white",

  tabActive:
    "bg-orange-500 text-white border-orange-400 shadow-lg shadow-orange-400/30",

  tabInactive:
    "bg-white text-orange-950 border-orange-300 hover:bg-pink-500 hover:text-white",

  tabHover:
    "hover:bg-pink-500 hover:text-white",

  tableHeader:
    "bg-orange-500 text-white border-orange-300",

  tableRow:
    "bg-white text-orange-950 border-orange-200 hover:bg-orange-50 hover:text-black",

  buttonPrimary:
    "bg-orange-500 hover:bg-orange-600 text-white",

  buttonSecondary:
    "bg-pink-500 hover:bg-pink-600 text-white",

  danger: "bg-red-500 text-white",
  success: "bg-green-500 text-white",
  warning: "bg-yellow-400 text-black",

  glow: "shadow-orange-400/30",
},

// =====================================================
// 20. DORM RETRO
// =====================================================

DORM_RETRO: {
  name: "Dorm Retro",

  bg: "bg-amber-50",
  card: "bg-orange-100",
  nav: "bg-amber-200",

  text: "text-amber-950",
  subText: "text-orange-700",

  accent: "text-red-700",
  accentBg: "bg-red-600",

  border: "border-amber-300",

  hover: "hover:bg-orange-200 hover:text-white",

  tabActive:
    "bg-red-600 text-white border-red-500 shadow-md shadow-red-400/30",

  tabInactive:
    "bg-orange-100 text-amber-950 border-amber-300 hover:bg-red-600 hover:text-white",

  tabHover:
    "hover:bg-red-600 hover:text-white",

  tableHeader:
    "bg-red-600 text-white border-red-400",

  tableRow:
    "bg-orange-100 text-amber-950 border-amber-200 hover:bg-orange-200 hover:text-black",

  buttonPrimary:
    "bg-red-600 hover:bg-red-700 text-white",

  buttonSecondary:
    "bg-amber-400 hover:bg-amber-500 text-black",

  danger: "bg-red-700 text-white",
  success: "bg-green-600 text-white",
  warning: "bg-yellow-400 text-black",

  glow: "shadow-orange-300/20",
},

// =====================================================
// 21. COFFEE HOUSE
// =====================================================

COFFEE_HOUSE: {
  name: "Coffee House",

  bg: "bg-stone-200",
  card: "bg-stone-100",
  nav: "bg-stone-800",

  text: "text-stone-900",
  subText: "text-stone-600",

  accent: "text-amber-700",
  accentBg: "bg-amber-700",

  border: "border-stone-400",

  hover: "hover:bg-stone-300 hover:text-white",

  tabActive:
    "bg-amber-700 text-white border-amber-600 shadow-md shadow-amber-500/30",

  tabInactive:
    "bg-stone-100 text-stone-900 border-stone-400 hover:bg-amber-700 hover:text-white",

  tabHover:
    "hover:bg-amber-700 hover:text-white",

  tableHeader:
    "bg-amber-700 text-white border-amber-600",

  tableRow:
    "bg-stone-100 text-stone-900 border-stone-300 hover:bg-stone-300 hover:text-black",

  buttonPrimary:
    "bg-amber-700 hover:bg-amber-800 text-white",

  buttonSecondary:
    "bg-stone-500 hover:bg-stone-600 text-white",

  danger: "bg-red-600 text-white",
  success: "bg-green-600 text-white",
  warning: "bg-yellow-500 text-black",

  glow: "shadow-amber-500/10",
},

  // =====================================================
// 22. WINTER FROST
// =====================================================

WINTER_FROST: {
  name: "Winter Frost",
  bg: "bg-cyan-50",
  card: "bg-white",
  nav: "bg-cyan-100",
  text: "text-sky-950",
  subText: "text-sky-700",
  accent: "text-cyan-700",
  accentBg: "bg-cyan-600",
  border: "border-cyan-200",

  hover: "hover:bg-cyan-100",
  tabActive: "bg-cyan-600 text-white border-cyan-700",
  tabInactive: "bg-white text-sky-950 border-cyan-200 hover:bg-cyan-600 hover:text-white",

  buttonPrimary: "bg-cyan-600 hover:bg-cyan-700 text-white",
  buttonSecondary: "bg-sky-500 hover:bg-sky-600 text-white",

  danger: "bg-red-500 text-white",
  success: "bg-green-500 text-white",
  warning: "bg-yellow-300 text-black",

  glow: "shadow-cyan-300/20",
},

// =====================================================
// 23. AUTUMN HARVEST
// =====================================================

AUTUMN_HARVEST: {
  name: "Autumn Harvest",
  bg: "bg-orange-50",
  card: "bg-yellow-100",
  nav: "bg-orange-200",
  text: "text-orange-950",
  subText: "text-amber-700",
  accent: "text-orange-700",
  accentBg: "bg-orange-600",
  border: "border-yellow-300",

  hover: "hover:bg-yellow-200",
  tabActive: "bg-orange-600 text-white border-orange-700",
  tabInactive: "bg-yellow-100 text-orange-950 border-yellow-300 hover:bg-orange-600 hover:text-white",

  buttonPrimary: "bg-orange-600 hover:bg-orange-700 text-white",
  buttonSecondary: "bg-yellow-400 hover:bg-yellow-500 text-black",

  danger: "bg-red-600 text-white",
  success: "bg-green-500 text-white",
  warning: "bg-yellow-300 text-black",

  glow: "shadow-orange-300/20",
},

// =====================================================
// 24. AQUA FLOW
// =====================================================

AQUA_FLOW: {
  name: "Aqua Flow",
  bg: "bg-teal-50",
  card: "bg-white",
  nav: "bg-teal-100",
  text: "text-teal-950",
  subText: "text-teal-700",
  accent: "text-cyan-600",
  accentBg: "bg-cyan-500",
  border: "border-teal-200",

  hover: "hover:bg-teal-100",
  tabActive: "bg-cyan-500 text-white border-cyan-600",
  tabInactive: "bg-white text-teal-950 border-teal-200 hover:bg-cyan-500 hover:text-white",

  buttonPrimary: "bg-cyan-500 hover:bg-cyan-600 text-white",
  buttonSecondary: "bg-teal-500 hover:bg-teal-600 text-white",

  danger: "bg-red-500 text-white",
  success: "bg-green-500 text-white",
  warning: "bg-yellow-300 text-black",

  glow: "shadow-cyan-300/20",
},

// =====================================================
// 25. ROYAL INDIGO
// =====================================================

ROYAL_INDIGO: {
  name: "Royal Indigo",
  bg: "bg-indigo-950",
  card: "bg-indigo-900",
  nav: "bg-indigo-950",
  text: "text-indigo-50",
  subText: "text-indigo-300",
  accent: "text-yellow-300",
  accentBg: "bg-yellow-400",
  border: "border-indigo-700",

  hover: "hover:bg-indigo-800",
  tabActive: "bg-yellow-400 text-black border-yellow-500",
  tabInactive: "bg-indigo-900 text-indigo-50 border-indigo-700 hover:bg-indigo-700 hover:text-white",

  buttonPrimary: "bg-yellow-400 hover:bg-yellow-500 text-black",
  buttonSecondary: "bg-indigo-700 hover:bg-indigo-600 text-white",

  danger: "bg-red-500 text-white",
  success: "bg-emerald-500 text-black",
  warning: "bg-yellow-300 text-black",

  glow: "shadow-indigo-500/30",
},
};